import { forms } from '../data/forms';

export const calculateBasarisizlik = (answers) => {
  const formDef = forms.find(f => f.id === 'basarisizlik_nedenleri');
  const totalQuestions = formDef?.items?.length || 30;
  
  // 🚀 DİNAMİK THRESHOLDS (Form bazlı eşikler)
  const thresholds = formDef?.thresholds || {
    highWeighted: 0.50, // Şiddet eşiği
    highRaw: 0.60,      // Yaygınlık eşiği
    medium: 0.25 
  };
  
  const categories = {
    'Verimli Çalışma ve Planlama': { ids: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], color: '#3b82f6', label: 'Çalışma Düzeni', weight: 1.0 },
    'Motivasyon ve İlgi': { ids: [11, 12, 13, 14, 15, 16, 17, 18], color: '#8b5cf6', label: 'Motivasyon', weight: 1.2 },
    'Aile ve Çevre': { ids: [19, 20, 21, 22, 23, 24], color: '#f59e0b', label: 'Aile/Çevre', weight: 1.8 },
    'Okul ve Öğretmen': { ids: [25, 26, 27, 28, 29, 30], color: '#10b981', label: 'Okul Uyumu', weight: 1.2 }
  };

  // O(1) Lookup Sözlüğü
  const questionCategoryMap = {};
  Object.entries(categories).forEach(([catName, catData]) => {
    catData.ids.forEach(id => {
      questionCategoryMap[id] = { name: catName, weight: catData.weight };
    });
  });

  // 🚀 1. GÜVENLİ MAX WEIGHT HESABI (Reduce ile)
  // Tüm soruların ağırlıklarının toplamı (Sistemin %100 referansı)
  const maxPossibleWeight = Object.values(questionCategoryMap).reduce((acc, cat) => acc + cat.weight, 0);

  let totalMarked = 0;
  let weightedTotal = 0; 
  let criticalCount = 0; 
  const markedItems = [];
  const categoryScores = {};

  Object.keys(categories).forEach(cat => {
    categoryScores[cat] = { count: 0, total: categories[cat].ids.length, percent: 0, items: [], meta: categories[cat] };
  });

  // Veri İşleme
  Object.keys(answers).forEach(key => {
    const val = answers[key];
    const qId = parseInt(key);

    if (val === true || val === "true" || val === 1 || val === "1") {
      totalMarked++;
      
      const mappedData = questionCategoryMap[qId];
      if (!mappedData || !categoryScores[mappedData.name]) return; // Güvenlik ağı

      const foundCategory = mappedData.name;
      const qWeight = mappedData.weight;

      categoryScores[foundCategory].count++;
      categoryScores[foundCategory].items.push(qId);
      weightedTotal += qWeight; 
      
      // 🚀 3. GRANULAR SEVERITY (İleride Heatmap ve AI için nümerik değer)
      const severityKey = qWeight >= 1.5 ? "critical" : qWeight >= 1.2 ? "high" : "normal";
      if (severityKey === "critical") criticalCount++;

      const questionText = formDef?.items.find(i => i.id === qId)?.text || `Madde ${qId}`;
      
      markedItems.push({ 
        id: qId, 
        text: questionText, 
        category: foundCategory, 
        severity: severityKey,
        severityScore: qWeight // Yapay Zekanın matematiği için ham skor
      });
    }
  });

  // Grafik verileri ve Yüzdeler
  const chartData = [];
  Object.keys(categoryScores).forEach(cat => {
    const data = categoryScores[cat];
    data.percent = Math.round((data.count / data.total) * 100) || 0; 
    chartData.push({ subject: data.meta.label, A: data.percent, fullMark: 100, color: data.meta.color });
  });

  const sortedCategories = Object.entries(categoryScores).sort((a, b) => b[1].percent - a[1].percent);
  const topCategory = sortedCategories.length > 0 ? sortedCategories[0][0] : "Belirsiz";
  const topCategoryPercent = sortedCategories.length > 0 ? sortedCategories[0][1].percent : 0;

  // 🚀 2. RAW vs WEIGHTED ÇİFT BAZLI HESAPLAMA (Klinik Hassasiyet)
  const rawRatio = totalQuestions > 0 ? (totalMarked / totalQuestions) : 0; // Yaygınlık
  const weightedRatio = maxPossibleWeight > 0 ? (weightedTotal / maxPossibleWeight) : 0; // Şiddet
  
  const riskScore = Math.round(weightedRatio * 100); 
  
  // 🚀 5. GÜVEN SKORU (Confidence Score)
  // Şiddet ve Yaygınlık birbirini doğruluyorsa sistem sonucundan çok emindir.
  const confidenceScore = Math.round(((rawRatio + weightedRatio) / 2) * 100);

  let riskLevel = "low";
  let summary = "Öğrencinin akademik başarısını engelleyen faktörler DÜŞÜK seviyededir.";
  let colorCode = "green";

  // Çift Yönlü Kontrol: Şiddet çok yüksekse VEYA çok yaygınsa
  if (weightedRatio > thresholds.highWeighted || rawRatio > thresholds.highRaw) { 
    riskLevel = "high";
    summary = `Akademik başarıyı engelleyen YÜKSEK düzeyde risk faktörleri tespit edilmiştir. (Karar Güveni: %${confidenceScore})`; 
    colorCode = "red"; 
  } else if (weightedRatio > thresholds.medium) { 
    riskLevel = "medium";
    summary = "Akademik başarıyı engelleyen ORTA düzeyde risk faktörleri tespit edilmiştir."; 
    colorCode = "amber"; 
  }

  // Klinik Override: Çocuk az işaretledi ama hepsi "Kritik" ise.
  if (criticalCount >= 3 && riskLevel !== "high") {
    riskLevel = "high";
    summary = `Kritik şiddette maddeler işaretlendiği için risk seviyesi YÜKSEK olarak güncellenmiştir. (Karar Güveni: %${confidenceScore})`;
    colorCode = "red";
  }

  // 🚀 4. DİNAMİK İÇGÖRÜ MOTORU (Form JSON'ından kural okuma altyapısı)
  let analysisText = `Öğrenci toplam ${totalQuestions} sorunun ${totalMarked} tanesini işaretlemiştir (Ağırlıklı Risk: ${riskScore}/100, Yaygınlık: %${Math.round(rawRatio*100)}).\n\nEn baskın problem alanı: **${topCategory}** (%${topCategoryPercent}).\n`;

  // Gelecekte 'formDef.insightRules' içinden gelecek kuralları işleyecek motor:
  const rules = formDef?.insightRules || [
    { targetCategory: "Aile ve Çevre", minRisk: 50, message: "⚠️ KRİTİK BULGU: Sorunun kaynağının okulla sınırlı kalmadığı görülmektedir. Acil veli görüşmesi önerilir." },
    { targetCategory: "Motivasyon ve İlgi", minRisk: 40, message: "📌 DİKKAT: İçsel motivasyon kaynaklarında eksiklikler görülmektedir. Tükenmişlik belirtileri izlenmelidir." }
  ];

  rules.forEach(rule => {
    if (topCategory === rule.targetCategory && riskScore >= rule.minRisk) {
      analysisText += "\n" + rule.message;
    }
  });

  if (criticalCount >= 3) {
    analysisText += `\n🚨 UYARI: İşaretlenen maddeler arasında ${criticalCount} adet 'Kritik' (Ağır Etkili) bulgu vardır.`;
  }

  const recommendations = `En baskın alan olan "${topCategory}" üzerine odaklanılmalıdır. Karar destek sisteminin bu analize güven skoru %${confidenceScore} olarak hesaplanmıştır.`;

  // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  // Mevcut riskLevel'ı masterRisk formatına bağlıyoruz.
  // Akademik başarısızlık genellikle "critical" (hayati kriz) kategorisine girmez, 
  // bu yüzden isCritical: false kalıyor ancak riskScore yüksekse sistem onu en üste çekecektir.

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: riskScore,
    masterRisk: riskLevel, // "high", "medium" veya "low" değerlerini buradan aktarıyoruz.
    isCritical: false, 
    domain: "academic",

    // 2. Mevcut Detaylı Veriler (Dashboard ve PDF için dokunmadık)
    summary,
    riskLevel, // Geriye dönük uyumluluk için eski anahtarı da koruyoruz
    confidenceScore,
    analysis: analysisText,
    risks: markedItems,
    chartData,
    categoryDetails: categoryScores,
    colorCode,
    recommendations
  };
};